import React from 'react';
import styles from './PlanCardNew.module.css';
interface PlanCardProps {
	isTopup: boolean;
	isPopular?: boolean;
	isBestValue?: boolean;
	oAmount: any;
	newAmount: any;
	discount: any;
	validity: string;
	balance: string;
	linkTo: any;
	ctaText: string;
	onClick: any;
	isTrial: boolean;
	isRecommended: boolean;
	packageName: string;
	noOfMsg: any;
}

const PlanCardNew: React.FC<PlanCardProps> = ({ isTopup, isPopular, isBestValue, oAmount, newAmount, discount, validity, balance, linkTo, ctaText, onClick, isTrial, isRecommended,packageName,noOfMsg }) => {
	return (
		<div className={`${styles.PlanCard} ${isRecommended ? styles.Recommended : ''} ${isTrial === true ? styles.FreeTrail : ''}`}>
			<div className={styles.PlanCardTitleWrp}>
				<div className={styles.PlanCardTitle}>
					<div className={styles.PlanCardName}>{packageName}</div>
					<div className={styles.PlanCardAmount}>
						<span className={styles.Rupees}>&#8377;</span>
						{newAmount}
						<div className={styles.PlanCardAmountReg}>+ GST</div>
					</div>
				</div>
			</div>
			<div className={styles.PlanCardInfo}>
				<div className={styles.PlanCardData}>{validity}</div>
			</div>
			<div className={styles.PlanCardInfo}>
				<div className={styles.PlanCardData}>{noOfMsg}</div>messages
			</div>
			<div className={styles.PlanCardInfo}>
				<div className={`${styles.PlanCardData} ${styles.Balance}`}>
					<span className={styles.Rupees}>&#8377;</span>
					{balance}
					{isTrial && <div>Welcome bonus</div>}
				</div>
			</div>
			<div className={styles.PlanCardInfo}>
				<span className={styles.PlanCta} onClick={onClick}>
					{isTrial === false ? ctaText : 'Start 30 day trial'}
				</span>
			</div>
		</div>
	);
};

export default PlanCardNew;
